// `embedding` must be in query_by for the hybrid search (PRODUCTS_VECTOR_QUERY)
// to find the auto-embedded field; without it Typesense rejects with
// "Vector query could not find any embedded fields".
export const PRODUCTS_QUERY_BY =
  "name,displayName,description,headline,productWrapperTitles,materials,benefits,embedding";

export const PRODUCTS_QUERY_BY_WEIGHTS = "4,4,2,2,1,1,1,1";

export const PRODUCTS_VECTOR_QUERY = "embedding:([], alpha: 0.3, distance_threshold: 0.20)";

// Single-select facets — bound to `useMenu` widgets. Declared via Algolia's
// `facets` Configure param so InstantSearch generates `facetsRefinements`
// (AND across attributes; a single value per attribute) — which Typesense
// receives as `filter_by: "attr:=[value]"`.
export const PRODUCTS_SINGLE_SELECT_FACETS: string[] = ["productType"];

export const MULTI_SELECT_FACETS = ["stickerType", "lamination", "materials", "benefits", "plpFlag"] as const;
export type MultiSelectFacet = (typeof MULTI_SELECT_FACETS)[number];

// Multi-select OR facets — bound to `useRefinementList({ operator: "or" })`.
// Declared via Algolia's `disjunctiveFacets` Configure param so InstantSearch
// generates `disjunctiveFacetsRefinements` (OR within attribute) — Typesense
// receives as `filter_by: "attr:=[v1,v2]"` (commas inside one bracket = OR).
// Putting these in `facets` instead would produce AND semantics within the
// same attribute (`attr:=[v1] && attr:=[v2]`), which is wrong for multi-select.
export const PRODUCTS_DISJUNCTIVE_FACETS: string[] = [...MULTI_SELECT_FACETS];

// Includes productType (single-select) for "Clear All" coverage of the entire facet set.
export const ALL_FACETS = ["productType", ...MULTI_SELECT_FACETS] as const;
export type Facet = (typeof ALL_FACETS)[number];
